"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uniqueId = uniqueId;
var idCounter = 0;

function uniqueId(prefix) {
  // eslint-disable-line
  idCounter += 1;
  return prefix ? prefix + "-" + idCounter : String(idCounter);
}